import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  cancelButton: {
    backgroundColor: `${theme.palette.icon.dark} !important`,
    borderRadius: theme.spacing(0.5),
    border: `${theme.palette.dividerV2.main}`,
  },
  container: {
    display: 'flex',
    gap: theme.spacing(5),
    '& .MuiAutocomplete-root': {
      width: '100%',
    },
  },
  footer: {
    marginTop: theme.spacing(5),
    display: 'flex',
    gap: theme.spacing(3),
    justifyContent: 'flex-end',
  },
}))
